import React from 'react';
import { Flex, FlexProps } from '@withjoy/joykit';

interface WrapperProps
  extends Readonly<{
    bigger?: boolean;
    wrapperOverrides?: FlexProps;
  }> {}

export const Wrapper: React.FC<WrapperProps> = ({ bigger = false, children, wrapperOverrides }) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      marginTop={[0, null, '36px']}
      {...wrapperOverrides}
    >
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width={['100%', null, `${bigger ? '5' : '3'}75px`]}
        {...wrapperOverrides}
      >
        {children}
      </Flex>
    </Flex>
  );
};
